// Every path of the area, written once: the routes declare `path:` from here, and the menu
// reads the same table. No imports, so a route can take its path without a cycle.

export const NAV_PATHS = {
  // The public ones. Why here and not as link-constants per route:
  // apps/frontend/docs/razionale-che-il-codice-indica.md.
  home: '/',
  signIn: '/sign-in',
  signUp: '/sign-up',
  // The two wizards behind the fork at /sign-up (issue #95).
  signUpClub: '/sign-up/club',
  signUpPlayer: '/sign-up/player',
  // The parent's own account, with no child and no club: the third card (ADR 0003).
  signUpParent: '/sign-up/parent',
  registrationStatus: '/registration-status',
  forgotPassword: '/forgot-password',
  forbidden: '/forbidden',
  activation: '/activation',
  enrolment: '/iscrizione',
  // The link for the tutore, which the child's request hands over (spec #278).
  guardianLink: '/tutore',
  // Task 6 registers the route; use-family-enrolment.ts already navigates here post-submit.
  familyEnrolmentStatus: '/family-enrolment-status',
  // «Da oggi decidi tu»: the step after the first access from 14, before any page (spec #278).
  autonomy: '/decidi-tu',
  officialDashboard: '/me/official',
  officialClub: '/me/official/club',
  officialPeople: '/me/official/people',
  officialInvite: '/me/official/people/new',
  officialPlayers: '/me/official/players',
  // A child of the list: the Panel «Aggiungi giocatore» over it.
  officialNewPlayer: '/me/official/players/new',
  officialRequests: '/me/official/requests',
  officialPitches: '/me/official/pitches',
  // The domain prefix for a person read as a giocatore. The demonstration page of §4.4
  // borrows it and does not own it: `/players/$personId` outlives it.
  players: '/players',
  // The domain prefix of a club's page: `/clubs/$clubId` opens to every reader with a session.
  clubs: '/clubs',
  teams: '/teams',
  leagues: '/leagues',
  matches: '/matches',
  // Not under `/me`, which is for the four role profiles: this is the account, and one
  // account has no role. Same path as the back office, reached the same way.
  settings: '/settings',
  myCoach: '/me/coach',
  myParent: '/me/parent',
  myParentAddChild: '/me/parent/add-child',
  myPlayer: '/me/player',
  myPlayerEdit: '/me/player/edit',
  subscriptions: '/subscriptions',
} as const

// The two rows below a list: derived, so the parent's path is still written once.
export const NAV_PARAM_PATHS = {
  leagueGroup: `${NAV_PATHS.leagues}/$groupId`,
  officialPerson: `${NAV_PATHS.officialPeople}/$personId`,
  officialRequest: `${NAV_PATHS.officialRequests}/$requestId`,
  // Task 7 fills the page in; the route is registered here because the list already links to it.
  officialPlayer: `${NAV_PATHS.officialPlayers}/$personId`,
  player: `${NAV_PATHS.players}/$personId`,
  playerHighlights: `${NAV_PATHS.players}/$personId/highlights`,
  club: `${NAV_PATHS.clubs}/$clubId`,
  subscriptionCheckout: `${NAV_PATHS.subscriptions}/$personId/checkout`,
} as const
